import defaultPet from "$/defaultLogo.svg";
import { formatDateToKorean } from "%/date";
import { NotifyDataTypes } from "./NotifySent";

const ContentComponent = ({ data }: { data: NotifyDataTypes }) => {
  return (
    <div className="p-4 mt-2 bg-white rounded-lg shadow-sm">
      <div>
        <div className="flex gap-3 items-start">
          <div className="flex overflow-hidden flex-shrink-0 justify-center items-center w-12 h-12 bg-gray-200 rounded-full border border-gray-300">
            <img
              src={data.profileImgUrl || defaultPet}
              alt="프로필"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="">
              <span className="text-sm font-medium text-gray-900">
                {data.petName}
              </span>
              <span className="ml-2 text-sm text-gray-500">
                {data.petWeight}Kg
              </span>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-500">
                {formatDateToKorean(data.dtSend)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2">{data.notiContents}</div>
    </div>
  );
};

export default ContentComponent;
